// src/utils/axiosInstance.js
import axios from 'axios';

// サブドメインを取得（例：demo.localhost → demo）
let subdomain = window.location.hostname.split('.')[0];

let baseURL;
if (window.location.hostname.includes('localhost')) {
  // 開発環境
  baseURL = `http://${window.location.hostname}:5001/api/shop`;
} else {
  // 本番環境
  baseURL = process.env.REACT_APP_API_URL
}
const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'X-Tenant-Name': subdomain,
  },
  withCredentials: true,
  timeout: 5000,
});

// レスポンス共通処理
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 404) {
      if (!window.location.pathname.startsWith('/not-found')) {
        window.location.replace('/not-found');
      }
      return new Promise(() => { });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;